import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { AdminAboutComponent } from './admin-about/admin-about.component';
import { AdminContactComponent } from './admin-contact/admin-contact.component';
import { AdminDestinationComponent } from './admin-destination/admin-destination.component';
import { AdminToursComponent } from './admin-tours/admin-tours.component';
import { AllToursComponent } from './all-tours/all-tours.component';
import { ToursDetailsComponent } from './tours-details/tours-details.component';
import { AdminHotelsComponent } from './admin-hotels/admin-hotels.component';
import { AdminToursDetailsComponent } from './admin-tours-details/admin-tours-details.component';
import { AdminUsersComponent } from './admin-users/admin-users.component';
import { AdminMenuComponent } from './admin-menu/admin-menu.component';
import { AdminLoginComponent } from './admin-login/admin-login.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { AdminInquiryComponent } from './admin-inquiry/admin-inquiry.component';
import { AdminLatestTemplateComponent } from './admin-latest-template/admin-latest-template.component';
import { AdminHomeSliderComponent } from './admin-home-slider/admin-home-slider.component';
import { BusPackagesComponent } from './bus-packages/bus-packages.component';
import { AdminReviewComponent } from './admin-review/admin-review.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'Index.html',
    component: HomeComponent
  },
  {
    redirectTo: 'home',
    path: '',
    pathMatch: 'full'
  },
  {
    path: 'about',
    component: AboutComponent
  },
  {
    path: 'contact',
    component: ContactComponent
  },
  {
    path: 'allTours',
    component: AllToursComponent
  },
  {
    path: 'allTours/:tours',
    component: AllToursComponent
  },
  {
    path: 'allTours/:query',
    component: AllToursComponent
  },
  {
    path: 'allTours/toursDetails/:id',
    component: ToursDetailsComponent
  },
  {
    path: 'busPackages/:id',
    component: BusPackagesComponent
  },  
  {
    path: 'admin',
    children: [
      {
        path: 'destination',
        component: AdminDestinationComponent
      },
      {
        path: 'logIn',
        component: AdminLoginComponent
      },
      {
        path: 'about',
        component: AdminAboutComponent
      },
      {
        path: 'contact',
        component: AdminContactComponent
      },
      {
        path: 'tours',
        component: AdminToursComponent
      },
      {
        path: 'menu',
        component: AdminMenuComponent
      },
      {
        path: 'hotels',
        component: AdminHotelsComponent
      },
      {
        path: 'users',
        component: AdminUsersComponent
      },
      {
        path: 'template',
        component: AdminLatestTemplateComponent
      },
      {
        path: 'toursDetails/:id',
        component: AdminToursDetailsComponent
      },
      {
        path: 'inquiry',
        component: AdminInquiryComponent
      },
      {
        path: 'homeslider',
        component: AdminHomeSliderComponent
      },
      {
        path: 'review',
        component: AdminReviewComponent
      }
    ]
  },
  {
    path: '**',
    component: NotFoundComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
